export default __webpack_public_path__ + "static/media/sell-postion-3.c32f69de.svg";